import * as React from 'react';
import { Button } from 'kui';
import { IAfterSkipDialogProps } from './types';
import './_AfterSkipDialog.scss';
import ReactHtmlParser from 'react-html-parser';
import { AFTER_SKIP_DIALOG_YES, CLASS_AFTER_SKIP_DIALOG } from './constants';

export const AfterSkipDialog = ({
    noLabel,
    subtitle,
    title,
    yesLabel = AFTER_SKIP_DIALOG_YES,
    onApply,
    onCancel,
}: IAfterSkipDialogProps) => {
    const className = CLASS_AFTER_SKIP_DIALOG;

    return <div className={className}>
        {title &&
            <div className={className + '__title'}>
                {title}
            </div>
        }
        <div className={className + '__subtitle'}>
            {ReactHtmlParser(subtitle)}
        </div>
        <div className={className + '__buttons'}>
            <Button
                size={'large'}
                onClick={onCancel}
            >
                {noLabel}
            </Button>
            <Button
                size={'large'}
                variant={'text'}
                className={className + '__no'}
                onClick={onApply}
            >
                {yesLabel}
            </Button>
        </div>
    </div>;
};
